import { render, staticRenderFns } from "./CommAdd.vue?vue&type=template&id=42ce1b6e&"
import script from "./CommAdd.vue?vue&type=script&lang=js&"
export * from "./CommAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports